document.addEventListener("DOMContentLoaded", function () {
  const prevButton = document.querySelector(".swiper-button-prev");
  const nextButton = document.querySelector(".swiper-button-next");

  function updateButtons() {
      if (window.innerWidth > 768) {
          prevButton.style.display = prevButton.getAttribute("aria-disabled") === "true" ? "none" : "block";
          nextButton.style.display = nextButton.getAttribute("aria-disabled") === "true" ? "none" : "block";
      } else {
          prevButton.style.display = "none";
          nextButton.style.display = "none";
      }
  }

  var swiper = new Swiper(".collection-swiper", {
      slidesPerView: 1.25,
      spaceBetween: 30,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      breakpoints: {
          768: {
              slidesPerView: 3,
          },
          990: {
              slidesPerView: 4,
              spaceBetween: 30,
          },
      },
      on: {
          init: updateButtons,
          slideChange: updateButtons,
          reachBeginning: updateButtons,
          reachEnd: updateButtons,
      },
  });

  updateButtons();
  window.addEventListener("resize", updateButtons);
});
